export const projects = [
    {
        name: "QuickQ Trivia",
        description: (
            "A daily online trivia game I designed, built, and run solo. "
            + "It's been played by over 10,000 people, and 100+ come back "
            + "every day for a fresh set of quiz-bowl-style questions drawn "
            + "from a bank of 2,000+ that I wrote myself."
        ),
        tags: ["React", "Flask", "AWS", "LLMs"],
        link: "https://quickqtrivia.com",
        linkText: "Check it out",
    },
    {
        name: "Google Wallet on Fitbit Ace LTE",
        description: (
            "I played a key role in launching the first Google Wallet product "
            + "for kids. I built the card management backend, worked on a web "
            + "flow for adding a card to the watch from a parent's iPhone, and "
            + "created the dashboards used to monitor the launch."
        ),
        tags: ["Android", "Kotlin", "Java"],
        link: "https://blog.google/products-and-platforms/devices/fitbit/fitbit-ace-back-to-school-update/",
        linkText: "About the product",
    },
    {
        name: "Alint + Fix",
        description: (
            "Developer tools that move static analysis and automated fixing "
            + "into Android engineers' local workflow at Google. Used tens of "
            + "thousands of times a week, meaningfully cutting the time and "
            + "iteration it takes to submit a change."
        ),
        tags: ["Developer Tools", "Static Analysis", "Go"],
    },
]

export const experience = [
    {
        role: "Software Engineer III, Google",
        team: "Android Developer Velocity",
        location: "London, UK",
        dates: "2025 \u2013 Present",
        summary: (
            "Building developer tools used by thousands of Android engineers, "
            + "focused on reducing latency in critical development workflows "
            + "and making internal tooling agent-friendly."
        ),
    },
    {
        role: "Software Engineer, Google",
        team: "Wallet on Wearables",
        location: "San Francisco, CA",
        dates: "2022 \u2013 2025",
        summary: (
            "One of three owners of the Google Wallet app on WearOS, used by "
            + "millions worldwide. Built card tokenization and management "
            + "features across wearable and mobile devices, and helped launch "
            + "Wallet for kids on the Fitbit Ace LTE."
        ),
    },
    {
        role: "Software Engineer I \u2013 II, Quorum",
        team: "Public Affairs Platform",
        location: "Washington, DC",
        dates: "2020 \u2013 2022",
        summary: (
            "Full-stack engineer on a public affairs platform serving Fortune "
            + "500 clients. Designed and owned key features for finding and "
            + "tracking legislation, mentored junior engineers, and conducted "
            + "technical interviews."
        ),
    },
    {
        role: "Software Engineer Intern, LiveRamp",
        team: "Enterprise Data Integration",
        location: "San Francisco, CA",
        dates: "2019",
        summary: (
            "Built internal tools and dashboards for an enterprise data "
            + "pipeline, plus an award-winning Hack Week prototype for "
            + "automated data ethics flagging."
        ),
    },
    {
        role: "Harvard University",
        team: "BA in Computer Science with honors, minor in Government",
        location: "Cambridge, MA",
        dates: "2016 \u2013 2020",
        summary: (
            "NCAA Division I athlete on the men's volleyball team "
            + "(EIVA All-Academic, 2019 and 2020)."
        ),
    },
]
